import React from "react";
import {Icon} from "semantic-ui-react";
import {formatCurrency} from "../../utils/commonutils";
import PayDetailDateCell from "./PayDetailDateCell";

// Identify TED (hybrid contract) days from the pay detail rows the backend already tags.
const isTedPayDetailRow = (row) =>
    (Array.isArray(row.indicatorKeys) && row.indicatorKeys.includes('tedDay')) ||
    (parseFloat(row.tedCollectionsPay) || 0) !== 0 ||
    (parseFloat(row.dayTedCollectionsRaw) || 0) !== 0;

// Renders the hybrid-contract "TED Collections" table. Returns null for non-hybrid providers
// (no pay detail row is tagged as a TED day), so it is a no-op for every existing contract.
export const showTedCollectionsTable = (payDetailsList) => {
    const tedRows = (payDetailsList || []).filter(isTedPayDetailRow);
    if (tedRows.length === 0) {
        return null;
    }
    const totalCollections = tedRows.reduce((sum, row) => sum + (parseFloat(row.dayTedCollectionsRaw) || 0), 0);
    const totalTedPay = tedRows.reduce((sum, row) => sum + (parseFloat(row.tedCollectionsPay) || 0), 0);
    // Prefer the configured hybridCollectionsPayPercent sent from the backend; fall back to
    // deriving it from the row totals (pay / collections) if it wasn't provided.
    const configuredPercentRow = tedRows.find(row => row.hybridCollectionsPercent !== undefined && row.hybridCollectionsPercent !== null);
    const configuredPercent = configuredPercentRow ? Number(configuredPercentRow.hybridCollectionsPercent) : null;
    const derivedPercent = totalCollections > 0 ? Math.round((totalTedPay / totalCollections) * 100) : 0;
    const appliedPercent = (configuredPercent !== null && !Number.isNaN(configuredPercent)) ? configuredPercent : derivedPercent;
    return (
        <div className="table-responsive mb20">
            <h5>TED Collections (Hybrid Contract){appliedPercent ? ` — ${appliedPercent}%` : ''}</h5>
            <table className="table table-striped table-hover">
                <thead>
                    <tr>
                        <th><div>SERVICE DATE</div></th>
                        <th><div>PRACTICE</div></th>
                        <th><div>COLLECTIONS</div></th>
                        <th><div>ACTUAL PAY{appliedPercent ? ` (${appliedPercent}%)` : ''}</div></th>
                    </tr>
                </thead>
                <tbody>
                    {tedRows.map((row, index) => (
                        <tr key={`tedCollectionsRow${index}`}>
                            <td><PayDetailDateCell row={row} /></td>
                            <td>{row.practice}</td>
                            <td>{formatCurrency(parseFloat(row.dayTedCollectionsRaw) || 0)}</td>
                            <td>{formatCurrency(parseFloat(row.tedCollectionsPay) || 0)}</td>
                        </tr>
                    ))}
                    <tr key="tedCollectionsRowTotal">
                        <td colSpan={2}><strong>Total</strong></td>
                        <td><strong>{formatCurrency(totalCollections)}</strong></td>
                        <td><strong>{formatCurrency(totalTedPay)}</strong></td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export const showFinancialNotesTable = (financialNoteList, financialNotes) => {
    const totalBcare = financialNoteList.reduce((sum, note) => sum + (parseFloat(note.bcare) || 0), 0);
    return(
        <div className="table-responsive mb20">
        <h5>Financial Notes</h5>
        <table className="table table-striped table-hover">
            <thead>
            <tr>
                <th>
                    <div>NOTES TYPE</div>
                </th>
                <th>
                    <div>DATE</div>
                </th>
                <th>
                    <div>TITLE</div>
                </th>
                <th>
                    <div>PRACTICE</div>
                </th>
                <th>
                    <div>PROVIDER</div>
                </th>
                <th>
                    <div>DESCRIPTION</div>
                </th>
                <th>
                    <div>FREQUENCY</div>
                </th>
                <th>
                    <div>TAXABLE</div>
                </th>
                <th>
                    <div>BCARE</div>
                </th>
                <th>
                    <div>AMOUNT</div>
                </th>
            </tr>
            </thead>
            <tbody>
            {
                financialNoteList.length > 0 ? (
                    <>
                        {financialNoteList.map((note, notekey) => (
                            <tr key={`financialNoteRow${notekey}`}>
                                <td>{note.notesType}</td>
                                <td>{note.dateString}</td>
                                <td>{note.title}</td>
                                <td>{note.practice}</td>
                                <td>{note.dentist}</td>
                                <td>{note.desc}</td>
                                <td>{note.frequency}</td>
                                <td>
                                    <Icon name={note.isTaxable ? 'check circle' : 'cancel'}
                                          color={note.isTaxable ? 'green' : 'red'}/>
                                </td>
                                <td>{formatCurrency(parseFloat(note.bcare) || 0)}</td>
                                <td>{formatCurrency(parseFloat(note.financialNotes) || 0)}</td>
                            </tr>
                        ))}
                        <tr key="financialNoteRowTotal">
                            <td colSpan={8}><strong>Total</strong></td>
                            <td><strong>{formatCurrency(totalBcare)}</strong></td>
                            <td><strong>{formatCurrency(financialNotes)}</strong></td>
                        </tr>
                    </>
                ) : (
                    <tr key="financialNoteRowNoRecords">
                        <td colSpan={10}><strong>No records found</strong></td>
                    </tr>
                )
            }
            </tbody>
        </table>
    </div>
    )
}